import getSortedBreadcrumbsFromLocation from '../location/useCases/getSortedBreadcrumbsFromLocation'
import { Location } from '../../types/models/Location.model'

export type GetDefaultFacetBreadcrumbsProps = {
  location: Location
  gatsbyLocation: {
    pathname: string
  }
  breadcrumbToSkip: string
  term: {
    title: string
  }
}

export interface GetDefaultFacetBreadcrumbs {
  (props: GetDefaultFacetBreadcrumbsProps): string[]
}

const generateBreadcrumbs: GetDefaultFacetBreadcrumbs = ({
  location,
  gatsbyLocation,
  term,
  breadcrumbToSkip
}) => {
  if (!location?.address_parts) {
    return gatsbyLocation.pathname.split('/').filter((i) => i)
  }
  const locationAddressPartsAsBreadcrumbs = getSortedBreadcrumbsFromLocation({
    location,
    locationTitleToSkip: breadcrumbToSkip
  })
  return [term?.title, ...locationAddressPartsAsBreadcrumbs].filter(
    Boolean
  ) as string[]
}

export default generateBreadcrumbs
